$(window).scroll(function() {
    // Code from websensepro.com
    //After scrolling 700px from the top...
    
  if($(window).width() > "1024"){
  if ( $(window).scrollTop() >= 500 ) {
    $('sticky-bar').css('display', 'block');

    //Otherwise remove inline styles and thereby revert to original stying
    } else {
    $('sticky-bar').css('display', 'none');
    }
}});


$(window).scroll(function(){
//here we check the viewport width
if($(window).width() < "1024"){
//if the viewport width is less then 1024 scrolltop is 800
  if ($(window).scrollTop() >= 900) {
         $('sticky-bar').css('display', 'block');

    //Otherwise remove inline styles and thereby revert to original stying
    } else {
    $('sticky-bar').css('display', 'none');
        
    }
}
});